import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomCachedResourceLoader } from './custom-resource.loader';
import { DisplayOptionsService } from './display-options.service';
import { ExceptionService } from './exception.service';
import { GlobalErrorHandler } from './global-error.handler';
import { SpinService } from './spin.service';

@NgModule({
  imports: [
    CommonModule,
  ],
  providers: [
    ExceptionService,
    SpinService,
    GlobalErrorHandler,
    CustomCachedResourceLoader,
    DisplayOptionsService
  ]
})

export class CoreModule { }
